<template>
    <div class="teacher">
        <SideMenu />
        <router-view />
    </div>
</template>

<script>
import SideMenu from "@/components/SideMenu/SideMenu.vue"
import { Splitpanes, Pane } from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'
import './index.scss';


export default {
    name: 'teacher',
    components: {
    SideMenu,
    Splitpanes,
    Pane,
},
    data() {
      return {
        mobile: false,
        showSideMenu: true,
        menuSize: {
          default: 30,
          min: 30,
          max: 70
        },
        contentSize: {
          default: 70,
          min: 30,
          max: 70
        }        
      };
    },
}
</script>

<style>

</style>